// resources/js/initComponents.js
document.addEventListener("DOMContentLoaded", function() {
    // Initialize components if they exist on the page
    if (document.querySelector('.before-after')) {
        import('./beforeAfter.js').then(module => {
            if (module.initBeforeAfter) {
                module.initBeforeAfter();
            }
        });
    }

    if (document.querySelector('[data-carousel]')) {
        import('./carousel.js').then(module => {
            if (module.initCarousels) {
                module.initCarousels();
            }
        });
    }
});